import { createFileRoute } from "@tanstack/react-router";

import { CirclePage } from "../../features/circle";

export const Route = createFileRoute("/_auth/circle")({
  component: CirclePage,
});
